<template>
  <div class="modal-content fm-modal-preview">
    <div class="modal-header">
      <h5 class="modal-title w-75 text-truncate">
        {{ data.filename }}
        <small class="text-muted pl-3"></small>
      </h5>
      <button type="button" aria-label="Close" @click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center">
      <transition name="fade" mode="out-in">
        <i
          v-if="!data.url"
          class="fas fa-spinner fa-spin fa-5x p-5 text-muted"
        />
        <img
          v-else
          v-bind:src="data.url"
          v-bind:alt="data.basename"
          v-bind:style="{ 'max-height': maxHeight + 'px' }"
        />
      </transition>
    </div>

    <div class="d-flex justify-content-end">
      <span class="d-block">
        <a
          class="btn btn-sm btn-primary"
          :href="data.url"
          target="_blank"
          :download="data.basename"
        >
          دانلود
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Preview",
  props: {
    data: Object
  },
  computed: {
    maxHeight() {
      if (this.$store.state.modal.modalHeight) {
        return this.$store.state.modal.modalHeight - 170;
      }

      return 300;
    }
  }
};
</script>

<style lang="scss">
.fm-modal-preview {
  .modal-body {
    padding: 0;

    img {
      max-width: 100%;
    }
  }

  & > .d-flex {
    padding: 1rem;
    border-top: 1px solid #e9ecef;
  }
}
</style>
